module.exports = __webpack_public_path__ + "static/media/lawn.a7b48ba1.jpg";